import { default as VuxDictManager, Dict } from 'ivux-dict-manager/src/index'
import { dictCode } from '@/api/sys-dict'

export default function(Vue, options = {}) {
	var { router, store, config } = options

	// install ivux-dict-manager
	VuxDictManager(Vue, {
		// 查询词典数据
		getDict(config) {
			return dictCode(config.code).then(res => {
				return res.data.list.map(v => ({
					name: v.code,
					pid: v.pid,
					list: (v.child || []).map(t => ({
						id: t.code,
						text: t.name,
            remark: t.remark,
            sortNum: t.sortNum
					}))
				}))
			})
		},
	})
}